import { render, staticRenderFns } from "./CampaignDesignations.vue?vue&type=template&id=277b47c4&scoped=true"
import script from "./CampaignDesignations.vue?vue&type=script&lang=js"
export * from "./CampaignDesignations.vue?vue&type=script&lang=js"
import style0 from "./CampaignDesignations.vue?vue&type=style&index=0&id=277b47c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b47c4",
  null
  
)

export default component.exports